import { Edit } from "@mui/icons-material";
import { Button, Grid, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { IGroup } from "../../../App/Typings/Groups";
import AddToGroupDialog from "../AddToGroup/AddToGroupDialog";
import { useAddToGroupDialogState } from "../AddToGroup/State/useAddToGroupDialogState";
import { GroupManageCandidatesButton } from "../GroupManageCandidatesButton/GroupManageCandidatesButton";
import { useGroupCandidateSelectionContext } from "../../State/GroupCandidateSelectionContext";
import { useGroupProfileContext } from "../../State/GroupProfileContext";

interface IGroupTableButtonsProps {
  setIsMoveCandidateModalOpen: (isOpen: boolean) => void;
}

export default function GroupTableButtons({ setIsMoveCandidateModalOpen }: IGroupTableButtonsProps) {
  const { group } = useGroupProfileContext();
  const addToGroupState = useAddToGroupDialogState(group);
  const {
    getters: { selectedCount, userSelected },
  } = useGroupCandidateSelectionContext();
  return (
    <Grid item xs={12} md={6} sx={{ marginLeft: { xs: 0, md: "auto" } }}>
      {group.isDynamic ? (
        <Tooltip data-test="editdynamicgroup-tooltip" title="Edit Dynamic Group" placement="top" arrow>
          <Button
            data-test="editdynamicgroup-button"
            variant="contained"
            color="primary"
            to={`/candidategroups/edit/${group.id}`}
            startIcon={<Edit />}
            aria-controls="editdynamicgroup-button"
            aria-haspopup="true"
            component={Link}
            fullWidth
            sx={{ height: "100%" }}
          >
            Edit Dynamic Group
          </Button>
        </Tooltip>
      ) : (
        <>
          <GroupManageCandidatesButton
            isArchived={group.isArchived}
            groupId={group.id}
            handleOpenAddToGroupDialog={addToGroupState.handlers.handleDialogOpen}
            userSelected={userSelected}
            selectedCandidatesCount={selectedCount}
            handleOpenMoveToGroupDialog={() => setIsMoveCandidateModalOpen(true)}
          />
          <AddToGroupDialog group={group} state={addToGroupState} />
        </>
      )}
    </Grid>
  );
}
